import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const initialState = {
  login: {
    mail: '',
    password: ''
  },
  signUp: {
    name: '',
    email: '',
    gender: '',
    lastName: '',
    dateOfBirth: null,
    password: '',
    passwordConfirmed: '',
    phone: '',
    country: '',
    city: ''
  },
  forgotPassword: {
    username: ''
  },
  forgotPasswordConfirmation: {
    password: '',
    confirmPassword: ''
  },
  changePassword: {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  },
  // emailNotifications: ["Images comments", "Video comments", "Follow Requests", "Report Status", "Comercial status", "Candles"]
}

const getters = {
  login(state) {
    return state.login
  },
  signUp(state) {
    return state.signUp
  },
  forgotPassword(state) {
    return state.forgotPassword
  },
  forgotPasswordConfirmation(state) {
    return state.forgotPasswordConfirmation
  },
  changePassword(state) {
    return state.changePassword
  }
}

export const state = { ...initialState }

export default {
  state,
  getters
}
